export { withConfirmation } from './model/hooks';
export { default as ConfirmationProvider } from './ui/ConfirmationProvider';
